export const contracts = {
	table: {
		columns: {
			status: "Status",
			contractId: "ID do contrato",
			requestType: "Tipo de solicitação",
			requestedAt: "Solicitado em",
			signatory: "Signatário",
			assignedAt: "Assinado em",
			expiredAt: "Vencimento em",
		},
		actionsTable: {
			seeContract: "Visualizar contrato",
			resendEmail: "Reenviar e-mail Clicksign",
		},
		solicitationType: {
			temporary: "Temporário",
			permanent: "Permanente",
		},
	},
	filter: {
		contractID: "Filtrar por ID do contrato",
		status: "Filtrar por status",
	},
	status: {
		pendingSignature: "Assinatura pendente",
		signatureExpired: "Assinatura expirada",
		contractExpired: "Contrato vencido",
		active: "Contrato ativo",
		closed: "Contrato encerrado",
	},
	title: "Contratos",
	header: {
		title: "Contratos",
		description: "Acompanhe suas solicitações de equipamentos e assinaturas",
	},
	xlsxFile: {
		filename: "contratos",
		tableTitle: "Contratos",
		columns: {
			id: "ID do contrato",
			status: "Status",
			createdAt: "Criado em",
			updatedAt: "Atualizado em",
			requestType: "Tipo de solicitação",
			requestModel: "Modelo de solicitação",
			contractPeriod: "Período do contrato",
			signatory: "Signatário",
			assignedAt: "Assinado em",
			expiredAt: "Vencimento em",
		},
	},
	sendEmailMessage: "E-mail reenviado com sucesso",
};
